import React from 'react';
type WaveDividerProps = {
  flip?: boolean;
  color?: string;
  className?: string;
};
export function WaveDivider({
  flip = false,
  color = '#F5FAFF',
  className = ''
}: WaveDividerProps) {
  const staticPath = 'M0,40 C280,110 520,0 720,50 C960,110 1180,10 1440,60 L1440,120 L0,120 Z';
  return <div aria-hidden className={`pointer-events-none w-full leading-[0] ${flip ? 'rotate-180' : ''} ${className}`} data-id="element-103" data-mp="irqvm1nyebef">
      <svg className="wave-animated h-16 w-full md:h-24" viewBox="0 0 1440 120" preserveAspectRatio="none" data-id="element-104" data-mp="422vh3ridisa">
        <path d={staticPath} fill={color} data-id="element-105" data-mp="3r8bz52xtgca5">
          <animate attributeName="d" dur="14s" repeatCount="indefinite" values={`${staticPath};M0,60 C260,10 540,100 760,50 C1000,0 1200,90 1440,40 L1440,120 L0,120 Z;${staticPath}`} data-id="element-106" data-mp="3r9mz0ro54zvz" />
        </path>
      </svg>
      <svg className="wave-static hidden h-16 w-full md:h-24" viewBox="0 0 1440 120" preserveAspectRatio="none" data-id="element-107" data-mp="3m9s8ip8a2cbg">
        <path d={staticPath} fill={color} data-id="element-108" data-mp="1ciemz7buvl7g" />
      </svg>
    </div>;
}